import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Type, ViewChild } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { isNullOrUndefined } from "projects/persian-date-picker/src/public-api";
import { ReportKindInfo } from "projects/sepidz-web-framework-data-grid/src/lib/report-kind";
import { ReportCopyComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-copy.component";
import { ReportSelectorComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-selector.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { SplashScreenService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/SplashScreenService";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { form_control, SaveReportFile } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer, VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { IncrementalKind, InvStatusKind, RowState, SellStatusKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { PeopleInfo } from "projects/sepidz-web-framework/src/lib/models/peopleInfo.model";
import { GridFilter, isNumber, LookupService, PagingDataResult, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { Observable } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AccVoucherFormComponent } from "src/app/backoffice/acc/accvoucher/accvoucher-form/accvoucher-form.component";
import { FormOperationKind } from "src/app/backoffice/inv/models/form-operation-kind.enums";
import { InvVoucherDetail } from "src/app/backoffice/inv/models/inv-voucher-detail.model";
import { InvVoucherHeader } from "src/app/backoffice/inv/models/inv-voucher-header.model";
import { InvVoucherKind, ReferenceVoucherKind } from "src/app/backoffice/inv/models/inv-voucher-kind.model";
import { ReferenceVoucherByVoucherKindFilterInfo } from "src/app/backoffice/inv/models/reference-voucher-byvoucher-kind-filter-info.model";
import { StockInfo } from "src/app/backoffice/inv/models/stock-info.model";
import { CreditFunctionKind } from "../../models/credit-function-kind.enums";
import { PriceListDetail } from "../../models/price-list-detail.model";
import { SellVoucherDetail } from "../../models/sell-voucher-detail.model";
import { SellVoucherHeader } from "../../models/sell-voucher-header.model";
import { SellVoucherDetailComponent } from "../sell-voucher-detail/sell-voucher-detail.component";
import { SellVoucherModalListComponent } from "../sell-voucher-modal-list/sell-voucher-modal-list.component";

@Component({
  selector: "ngx-sell-voucher-form",
  templateUrl: "./sell-voucher-form.component.html",
  styleUrls: ["./sell-voucher-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SellVoucherFormComponent extends BaseFormComponent<SellVoucherHeader> {
  @ViewChild("detail") public detail: SellVoucherDetailComponent;
  inputEditorform: Type<any>;
  currentVoucherKind: InvVoucherKind;
  isCheckingCredit: boolean = false;
  valueIsSetting: boolean = false;
  HasPricelist: boolean = false;
  isCreatingAccVoucher: boolean = false;
  CreatingAccVoucherHasError: boolean = false;
  CreatedVoucherKindReferencedToHasError: boolean = false;
  CreatedVoucherKindReferencedTo: boolean = false;
  StockInfoColumns: form_control[];
  CustomerVouchers: SellVoucherHeader[] = [];
  DetailLedgerColumnDetailLedger: form_control[];
  CustomerColumns: form_control[];
  CustomerVoucherColumns: form_control[];
  DetailLedgerColumnSellDetailLedger: form_control[];
  SellVoucherDetailColumns: form_control[];
  DiscountColumns: form_control[];
  dataList: StockInfo[] = [];
  ReferenceToVoucherKinds: InvVoucherKind[];
  CurrentReferenceToVoucherKindId: number;
  filterdDataList: StockInfo[] = [];
  activeTabTitle: string;
  InvBalanceColumnswidth: number = 100;
  isValidating: boolean = false;
  isOkForLoad: boolean = false;
  hasPriceRefresh: boolean = false;
  isNewVoucher: boolean = false;
  erroremessage: string;
  isloading: boolean = false;
  goodsError: boolean = false;
  maxCodeLoading: boolean = false;
  confirmLabel: string;
  accVoucherCaption: string;
  currentReport: string = "print";
  reportList: SaveReportFile[];
  isRefreshingData: boolean = false;
  reportKinds = ReportKindInfo.reportKinds;
  isFristReplaceGoodsSimilar: boolean = true;
  @ViewChild(SellVoucherDetailComponent) SellVoucherDetailComponent: SellVoucherDetailComponent;
  @HostListener("window:keydown", ["$event"])
  cs(e: KeyboardEvent) {
    if (document.hidden) return;
    if (e.ctrlKey && e.shiftKey && !e.altKey && (e.key.toUpperCase() === "P" || e.key === "ح" || e.key === "\\")) {
      e.preventDefault();
      this.currentReport = "preview";
      this.changeReport("preview");
    }
    if (e.ctrlKey && e.altKey && !e.shiftKey && (e.key.toUpperCase() === "P" || e.key === "ح")) {
      e.preventDefault();
      this.currentReport = "editReport";
      this.changeReport("editReport");
    }
    if (e.ctrlKey && !e.altKey && !e.shiftKey && (e.key.toUpperCase() === "P" || e.key === "ح")) {
      e.preventDefault();
      this.currentReport = "print";
      this.changeReport("print");
    }
    if (e.ctrlKey && (e.key.toUpperCase() === "N" || e.key === "د")) {
      e.preventDefault();
      this.newVoucher();
    }
    if (e.ctrlKey && (e.key.toUpperCase() === "D" || e.key === "ی" || e.key === "ی")) {
      e.preventDefault();
      this.deleteVoucher();
    }
    if (e.ctrlKey && e.shiftKey && (e.key.toUpperCase() === "S" || e.key === "س")) {
      e.preventDefault();
      this.voucherConfirm();
    }
    if (e.ctrlKey && (e.key.toUpperCase() === "R" || e.key === "ق")) {
      e.preventDefault();
      this.ngOnInit().then();
    }
  }
  footerColumns: form_control[];
  transportColumns: form_control[];

  constructor(
    private lookupservice: LookupService,
    private splashScreenService: SplashScreenService,
    private splashFormService: SplashFormService,
    private missetup: MisSetupService,
    __id: FormContainerModel,
    _tabsservice: TabularService,
    protected cd: ChangeDetectorRef,
    private datatransfer: Datatransfer,
    protected selectorService: SelectorService,
    _VoucherKindInfo: VoucherKindInfo
  ) {
    super(selectorService, cd);
    this._id = __id;
    this.currentrow = this.datatransfer?.currentrow;
    if (this.datatransfer?.apiName) this.apiName = this.datatransfer?.apiName;
    if (this.datatransfer?.areaName) this.areaName = this.datatransfer?.areaName;
    this.VoucherKind = _VoucherKindInfo;
    this.tabsservice = _tabsservice;
    this.currentFiscalYear;
  }
  get filterEntity() {
    let entity: ReferenceVoucherByVoucherKindFilterInfo = <ReferenceVoucherByVoucherKindFilterInfo>{};
    entity.FiscalYearId = this.currentFiscalYear.Id;
    entity.DetailLedgerId = this.formGroup.controls["DetailLedgerId"] ? this.formGroup.controls["DetailLedgerId"].value : null;
    entity.WarehouseId = this.formGroup?.controls["WarehouseId"] ? this.formGroup?.controls["WarehouseId"]?.value : null;
    entity.ReferencedVoucherKindId = this.formGroup?.controls["ReferenceVoucherKindId"]
      ? this.formGroup?.controls["ReferenceVoucherKindId"]?.value
      : null;
    entity.VoucherDate = this.formGroup?.controls["VoucherDate"] ? this.formGroup?.controls["VoucherDate"]?.value : null;
    entity.VoucherKindId = this.formGroup?.controls["VoucherKindId"] ? this.formGroup?.controls["VoucherKindId"]?.value : null;
    entity.WarehouseTransferId = this.formGroup?.controls["WarehouseTransferId"] ? this.formGroup?.controls["WarehouseTransferId"]?.value : null;
    return entity;
  }
  get ReferenceVoucherKindId() {
    if (this.formGroup && this.formGroup?.controls["ReferenceVoucherKindId"]) return this.formGroup?.controls["ReferenceVoucherKindId"]?.value;
    return undefined;
  }
  get detailLedgerLevel(): number {
    return this.missetup.getnumber("ACC", "DLLEVEL");
  }
  get hasReference() {
    return (
      this.currentVoucherKind !== undefined &&
      this.currentVoucherKind.ReferenceVoucherKinds !== undefined &&
      this.currentVoucherKind.ReferenceVoucherKinds.length > 0
    );
  }
  get hasReferenceRequired() {
    return (
      this.currentVoucherKind !== undefined &&
      this.currentVoucherKind.ReferenceVoucherKinds !== undefined &&
      this.currentVoucherKind.ReferenceVoucherKindIsRequired
    );
  }
  get currentFiscalYear() {
    return this.accountService.authService.currentFiscalYear;
  }
  get hasTaxDuty() {
    return this.currentVoucherKind && this.currentVoucherKind?.HasTaxDuty;
  }
  get hasDiscount() {
    return this.currentVoucherKind && this.currentVoucherKind?.HasDiscount;
  }
  get Priceable() {
    return this.currentVoucherKind && this.currentVoucherKind?.Priceable;
  }
  get ShowStockAmount() {
    this.InvBalanceColumnswidth = 70 + (!this.HasTransportInterface ? 15 : 0) + (!this.Priceable ? 15 : 0);
    return this.currentVoucherKind && this.currentVoucherKind?.ShowStockAmount;
  }

  get HasJournalVoucher() {
    return this.currentVoucherKind?.HasJournalVoucher;
  }
  get HasTransportInterface() {
    return this.currentVoucherKind && this.currentVoucherKind?.HasTransportInterface;
  }

  setLoaclColumns() {
    var col = this.orignalColumns.filter((f) => f.formVisible && f.areaName === "Transport");
    this.transportColumns = col.sort((a, b) => a.order - b.order);

    var col = this.orignalColumns.filter((f) => f.formVisible && f.areaName === "Footer");
    this.footerColumns = col.sort((a, b) => a.order - b.order);
    this.getDetailLedgerColumn("DetailLedger");
    this.getDetailLedgerColumn("SellDetailLedger");

    this.CustomerColumns = [];
    this.CustomerColumns.push(<form_control>{
      label: "اعتبارنقدی",
      controlType: FormControlTypes.textbox,
      modelName: "ConsumedCredit",
      disabled: true,
      name: "ConsumedCredit",
      order: 0,
      textType: "number",
      withComma: true,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerColumns.push(<form_control>{
      label: "اعتباراسنادي",
      controlType: FormControlTypes.textbox,
      modelName: "DocumentCredit",
      disabled: true,
      name: "DocumentCredit",
      order: 1,
      textType: "number",
      withComma: true,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerColumns.push(<form_control>{
      label: "مانده نقدی",
      controlType: FormControlTypes.textbox,
      modelName: "ConsumedCreditRemain",
      disabled: true,
      name: "ConsumedCreditRemain",
      order: 1,
      textType: "number",
      withComma: true,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerColumns.push(<form_control>{
      label: "مانده اسنادي",
      controlType: FormControlTypes.textbox,
      modelName: "DocumentCreditRemain",
      disabled: true,
      name: "DocumentCreditRemain",
      order: 1,
      textType: "number",
      withComma: true,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerColumns.push(<form_control>{
      label: "مانده حساب",
      controlType: FormControlTypes.textbox,
      modelName: "CustomerRemain",
      disabled: true,
      name: "CustomerRemain",
      order: 1,
      textType: "number",
      withComma: true,
      formVisible: true,
      listVisible: true,
      required: false,
    });

    this.CustomerVoucherColumns = [];
    this.CustomerVoucherColumns.push(<form_control>{
      label: "نوع سند",
      controlType: FormControlTypes.textbox,
      modelName: "VoucherKind.Title",
      disabled: true,
      name: "VoucherKindTitle",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerVoucherColumns.push(<form_control>{
      label: "شماره سند",
      controlType: FormControlTypes.textbox,
      modelName: "VoucherNo",
      disabled: true,
      name: "VoucherNo",
      order: 1,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerVoucherColumns.push(<form_control>{
      label: "شماره پیگیری",
      controlType: FormControlTypes.textbox,
      modelName: "SlaveNo",
      disabled: true,
      name: "SlaveNo",
      order: 2,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerVoucherColumns.push(<form_control>{
      label: "تاریخ سند",
      controlType: FormControlTypes.textbox,
      modelName: "VoucherDate",
      disabled: true,
      name: "ShamsiVoucherDate",
      order: 3,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerVoucherColumns.push(<form_control>{
      label: "سند مبنا",
      controlType: FormControlTypes.textbox,
      modelName: "ReferenceVoucherKind.Title",
      disabled: true,
      name: "ReferenceVoucherKindTitle",
      order: 4,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerVoucherColumns.push(<form_control>{
      label: "مالیات و عوارض",
      controlType: FormControlTypes.textbox,
      modelName: "Tax",
      disabled: true,
      name: "Tax",
      order: 5,
      textType: "number",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerVoucherColumns.push(<form_control>{
      label: "تخفیف",
      controlType: FormControlTypes.textbox,
      modelName: "DiscountAmount",
      disabled: true,
      name: "DiscountAmount",
      order: 6,
      textType: "number",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerVoucherColumns.push(<form_control>{
      label: "جمع خالص",
      controlType: FormControlTypes.textbox,
      modelName: "TotalPrice",
      disabled: true,
      name: "TotalPrice",
      order: 7,
      textType: "number",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerVoucherColumns.push(<form_control>{
      label: "تسویه شده",
      controlType: FormControlTypes.textbox,
      modelName: "PaymentValue",
      disabled: true,
      name: "PaymentValue",
      order: 8,
      textType: "number",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerVoucherColumns.push(<form_control>{
      label: "مانده",
      controlType: FormControlTypes.textbox,
      modelName: "RemainValue",
      disabled: true,
      name: "RemainValue",
      order: 9,
      textType: "number",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerVoucherColumns.push(<form_control>{
      label: "سند حسابداری",
      controlType: FormControlTypes.textbox,
      modelName: "AccVoucherNo",
      disabled: true,
      name: "AccVoucherNo",
      order: 10,
      textType: "number",
      withComma: false,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerVoucherColumns.push(<form_control>{
      label: "شماره معطوف",
      controlType: FormControlTypes.textbox,
      modelName: "ReferenceToVoucherNo",
      disabled: true,
      name: "ReferenceToVoucherNo",
      order: 11,
      textType: "number",
      withComma: false,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerVoucherColumns.push(<form_control>{
      label: "تاریخ وصول",
      controlType: FormControlTypes.textbox,
      modelName: "ShamsiReceiptDate",
      disabled: true,
      name: "ShamsiReceiptDate",
      order: 12,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.CustomerVoucherColumns.push(<form_control>{
      label: "توضیحات",
      controlType: FormControlTypes.textbox,
      modelName: "Comment",
      disabled: true,
      name: "Comment",
      order: 13,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
  }
  getcolumns(key: string, columnnumber: number = 4) {
    let col: form_control[] = [];

    if (key === "columns")
      col = this.orignalColumns.filter(
        (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
      );
    else col = this.orignalColumns.filter((f) => f.areaName === key && f.formVisible);
    this.setColumnNumber(col, columnnumber);
    return col.sort((a, b) => a.order - b.order);
  }
  getDetailLedgerColumn(key: string) {
    this.setDetaiLedgerVisble();
    if (key === "DetailLedger") this.DetailLedgerColumnDetailLedger = this.getcolumns(key, 6);
    else this.DetailLedgerColumnSellDetailLedger = this.getcolumns(key, 6);
  }
  setReferenceVoucherColumn() {
    this.httpCommonService
      .get("SellVoucherHeader/GetReferenceVoucherInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: form_control[]) => {
          this.selectorService.setColumns("ReferenceId", data);
        },
        (error) => this.getFailedHelper(error)
      );
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.StockInfoColumns = undefined;
    this.SellVoucherDetailColumns = undefined;
    this.DiscountColumns = undefined;
    this.dataList = undefined;
    this.filterdDataList = undefined;
  }
  async ngOnInit() {
    if (this.currentFiscalYear) {
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
        }
      });
    this.SetHasPricelist();
    this.selectorService.setDataList("DeliveryPlaceId", []);
    this.isNewVoucher = false;
    if (this.detail !== undefined)
      setTimeout(() => {
        this.detail.setColumns();
      }, 100);
    if (this.SellVoucherDetailComponent !== undefined) setTimeout(() => this.SellVoucherDetailComponent.setColumns(), 300);
    this.apiName = "SellVoucherHeader";
    if (!this.areaName) this.areaName = "SellCustomer";
    if (this.currentrow && (this.currentrow as SellVoucherHeader).VoucherKindTitle) {
      this.label = (this.currentrow as SellVoucherHeader).VoucherKindTitle + `(${(this.currentrow as SellVoucherHeader).VoucherNo})`;
      this.tabsservice.setTabTitle(this._id.metadata.id, this.getFormTitle());
    }
    if (this.ShowStockAmount) this.setStockInfoColumns();

    this.ReportSelectorForm = ReportSelectorComponent;
    this.ReportCopyForm = ReportCopyComponent;
    this.pathPreFix = "SELL";
    this.reportName = "SellCustomerDocument";
    await super.ngOnInit();
    this.setCurrentVoucherKind();
    this.loadReports();
    this.selectorService.submitted$.next(false);
    this.setReferenceVoucherColumn();
    if (this.detail) {
      this.detail.dataList = this.model?.SellVoucherDetailList ?? [];
      this.detail.ngOnInit();
    }
  }
  loadVoucherList() {
    this.inputEditorform = SellVoucherModalListComponent;
    this.dialogService
      .open(
        this.inputEditorform,
        {
          label: this.label,
          currentVoucherKindId: this.currentVoucherKind.Id,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (model) => {
        if (model) {
          if (this.detail) this.detail.cancelHandler();
          this.currentrow = model;
          this.id = this.currentrow.Id;
          await this.ngOnInit();
        }
      });
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
    if ($event.tabTitle === "اطلاعات مشتری") {
      this.setCustomerInfo();
    }
  }
  private CheckCredit() {
    if (this.formGroup.get("SubLedgerId").value) this.setCustomerInfo().then();
    if (this.isCheckingCredit) return false;
    this.isCheckingCredit = true;
    let CustomerRemain =
      (this.model?.Customer?.ConsumedCreditRemain ?? 0) -
      this.model?.SellVoucherDetailList?.getSumWithKey("TotalPrice") +
      (this.model?.TotalPrice ? this.model?.TotalPrice : 0);
    let DocumentCreditRemain =
      (this.model?.Customer?.DocumentCreditRemain ?? 0) -
      this.model.SellVoucherDetailList.getSumWithKey("TotalPrice") +
      (this.model?.TotalPrice ? this.model?.TotalPrice : 0);
    if (DocumentCreditRemain < 0 && (this.model?.Customer?.DocumentCredit ?? 0) > 0 && this.model?.Customer?.BasedReputationCode > 1) {
      if (this.currentVoucherKind.CreditFunctionKindCode === CreditFunctionKind.Stop) {
        this.sts.showDialog(
          `اعتبار اسنادي ${this.model?.Customer?.CustomerTitle} ${this.model?.Customer?.CustomerDisplayName} به مبلغ ${
            DocumentCreditRemain ? DocumentCreditRemain : 0
          } كسري دارد.`,
          "هشدار"
        );
        this.isCheckingCredit = false;
        return false;
      } else {
        this.sts.showDialog(
          `اعتبار اسنادي ${this.model?.Customer?.CustomerTitle} ${this.model?.Customer?.CustomerDisplayName} به مبلغ ${
            DocumentCreditRemain ? DocumentCreditRemain : 0
          } كسري دارد. آيا از تائيد اطلاعات مطمئن هستيد؟`,
          "هشدار",
          DialogType.confirm,
          () => {
            if (CustomerRemain < 0 && this.model?.Customer?.ConsumedCredit > 0 && this.model?.Customer?.BasedReputationCode == 1) {
              if (this.currentVoucherKind.CreditFunctionKindCode === CreditFunctionKind.Stop) {
                this.sts.showDialog(
                  `اعتبار نقدی ${this.model?.Customer?.CustomerTitle} ${this.model?.Customer?.CustomerDisplayName} به مبلغ ${
                    CustomerRemain ? CustomerRemain : 0
                  } كسري دارد.`,
                  "هشدار"
                );
                this.isCheckingCredit = false;
                return false;
              } else {
                this.sts.showDialog(
                  `اعتبار نقدی ${this.model?.Customer?.CustomerTitle} ${this.model?.Customer?.CustomerDisplayName} به مبلغ ${
                    CustomerRemain ? CustomerRemain : 0
                  } كسري دارد. آيا از تائيد اطلاعات مطمئن هستيد؟`,
                  "هشدار",
                  DialogType.confirm,
                  () => {
                    this.erroremessage = "اعتبار نقدی کسری دارد.";
                  }
                );
                this.isCheckingCredit = false;
                return false;
              }
            }
          },
          () => {
            this.isCheckingCredit = false;
          }
        );
      }
    }
    this.isCheckingCredit = false;
    return true;
  }
  async getCustomerRemain() {
    var temp = this.currentFiscalYear;
    if (!this.formGroup.get("SubLedgerId").value) return;
    let filter: GridFilter[] = [];
    filter.push({ Type: "F", Filed: "FiscalYearId", Value: this.currentFiscalYear?.Id, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    filter.push({
      Type: "F",
      Filed: "BranchId",
      Value: this.accountService.authService.currentBranchId,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });
    if (this.formGroup?.get("CustomerId")?.value)
      filter.push({
        Type: "F",
        Filed: "CustomerId",
        Value: this.formGroup?.get("CustomerId")?.value,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 0,
      });
    filter.push({ Type: "F", Filed: "ReceiptDate", Value: this.formGroup.get("VoucherDate").value, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    filter.push({ Type: "F", Filed: "CheckCredit", Value: this.currentVoucherKind.HasCredit, Logic: "and", Operator: "neq", Skip: 0, Take: 0 });
    filter.push({ Type: "F", Filed: "SubLedgerId", Value: this.formGroup.get("SubLedgerId").value, Logic: "and", Operator: "neq", Skip: 0, Take: 0 });
    await this.httpCommonService
      .GetFilterGrid<any>("SellCustomer/GetCustomerRemain", filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (x) => {
          this.model.Customer = x;
          this.setValue("ConsumedCredit", this.model?.Customer?.ConsumedCredit);
          this.setValue("DocumentCredit", this.model?.Customer?.DocumentCredit);
          this.setValue("ConsumedCreditRemain", this.model?.Customer?.ConsumedCreditRemain);
          this.setValue("DocumentCreditRemain", this.model?.Customer?.DocumentCreditRemain);
          this.setValue("CustomerRemain", this.model?.Customer?.CustomerRemain);
          this.cd.markForCheck();
        },
        (error) => {
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در بارگذاری اطلاعات");
        }
      );
  }
  async setCustomerInfo() {
    this.cd.markForCheck();
    if (!this.formGroup?.get("CustomerId")?.value) return;
    await this.getCustomerRemain();
    let filter: GridFilter[] = [];
    filter.push({ Type: "F", Filed: "FiscalYearId", Value: this.currentFiscalYear?.Id, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    filter.push({
      Type: "F",
      Filed: "BranchId",
      Value: this.accountService.authService.currentBranchId,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });
    if (this.formGroup?.get("CustomerId")?.value)
      filter.push({
        Type: "F",
        Filed: "CustomerId",
        Value: this.formGroup?.get("CustomerId")?.value,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 0,
      });
    filter.push({ Type: "F", Filed: "StatusKindCode", Value: 5, Logic: "and", Operator: "neq", Skip: 0, Take: 0 });
    filter.push({ Type: "F", Filed: "RemainValue", Value: 0, Logic: "and", Operator: "neq", Skip: 0, Take: 0 });
    if (this.model.Id) filter.push({ Type: "F", Filed: "Id", Value: this.model.Id, Logic: "and", Operator: "neq", Skip: 0, Take: 0 });
    await this.httpCommonService
      .GetFilterGrid<any>("SellVoucherHeader/GetWithCustomFilter", filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (x: PagingDataResult<any>) => {
          this.CustomerVouchers = ((x?.Data ?? x) as any[]) || [];
        },
        (error) => {
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در بارگذاری اطلاعات");
        }
      );
  }
  setStatusKind() {
    if (!this.model.StatusKindId) {
      this.lookupservice
        .getLookupbyCode("SELL", "StatusKind", SellStatusKind.Registered)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            this.model.StatusKindId = x.Id;
            this.model.StatusKindCode = x.Code;
            this.model.StatusKindTitle = x.Title;
            this.setValue("StatusKindId", this.model.StatusKindId);
            this.setValue("StatusKindCode", this.model.StatusKindCode);
            this.setValue("StatusKindTitle", this.model.StatusKindTitle);
          }
        });
    }
  }
  setConfirmStatusKind() {
    this.lookupservice
      .getLookupbyCode("SELL", "StatusKind", SellStatusKind.Confirmed)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        if (x && x.Id) {
          this.model.StatusKindId = x.Id;
          this.model.StatusKindCode = x.Code;
          this.model.StatusKindTitle = x.Title;
          this.setValue("StatusKindId", this.model.StatusKindId);
          this.setValue("StatusKindCode", this.model.StatusKindCode);
          this.setValue("StatusKindTitle", this.model.StatusKindTitle);
        }
      });
  }
  setdefault() {
    if (this.model.CustomerId) this.SetDeliveryPlace(this.model.CustomerId);
    if (this.model.ReserveBalance === undefined) this.model.ReserveBalance = false;
    if (this.model.VoucherKindId) {
      this.VoucherKind = new VoucherKindInfo();
      this.VoucherKind.VoucherKindId = this.model.VoucherKindId;
      this.setCurrentVoucherKind();
    }
    if (!this.model.Invoicecredit) this.model.Invoicecredit = 0;
    if (!this.model.VoucherDate && this.currentVoucherKind && this.currentVoucherKind.ToDayDate) this.model.VoucherDate = new Date();
    if (!this.model.SellVoucherDetailList) this.model.SellVoucherDetailList = [];

    if (!this.model.FiscalYearId && this.currentFiscalYear) {
      this.model.FiscalYearId = this.currentFiscalYear.Id;
      this.model.Year = this.currentFiscalYear.Year;
    } else if (!this.model.FiscalYearId) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.model.FiscalYearId = x.Id;
          this.model.Year = x.Year;
          this.setValue("FiscalYearId", x.Id);
          this.setValue("Year", x.Year);
        }
      });
    }
    if (!this.model.StatusKindId) {
      this.setStatusKind();
      this.confirmLabel = "تایید سند";
    }
    if (this.model.StatusKindCode >= SellStatusKind.Confirmed) this.confirmLabel = "برگشت از تایید";
    else this.confirmLabel = "تایید";

    if (!this.model.VoucherKindId && this.currentVoucherKind) {
      this.model.VoucherKindId = this.currentVoucherKind.Id;
      this.model.VoucherKindCode = this.currentVoucherKind.Code;
      this.model.VoucherKindTitle = this.currentVoucherKind.Title;
    } else if (!this.model.VoucherKindId && this.VoucherKind.VoucherKindId) {
      this.model.VoucherKindId = this.VoucherKind.VoucherKindId;
    }
    if (!this.model.BranchId) {
      this.model.BranchId = this.accountService.authService.currentBranchId;
    }
    if (!this.model.SlaveNo) this.model.SlaveNo = 0;
    if (!this.model.SumDeduction) this.model.SumDeduction = 0;
    if (!this.model.SumPrice) this.model.SumPrice = 0;
    if (!this.model.SumSurplusage) this.model.SumSurplusage = 0;
    if (!this.model.TotalPrice) this.model.TotalPrice = 0;
    if (!this.model.TotalDeduction) this.model.TotalDeduction = 0;
    if (!this.model.TotalSurplusage) this.model.TotalSurplusage = 0;
    if (!this.model.DiscountAmount) this.model.DiscountAmount = 0;
    if (!this.model.Tax) this.model.Tax = 0;
    if (!this.model.TotalDeduction) this.model.TotalDeduction = 0;
    if (this.model.StatusKindCode === SellStatusKind.AccountRegistered) this.accVoucherCaption = "حذف سند حسابداری";
    else this.accVoucherCaption = "سند حسابداری";
    this.setDefaultValues();
    if (this.model?.SellVoucherDetailList.length > 0) this.setValue("WarehouseId", this.model.SellVoucherDetailList[0].WarehouseId);
    if (this.detail && this.model && this.model?.SellVoucherDetailList && this.model?.SellVoucherDetailList?.length > 0) {
      this.model.SellVoucherDetailList.forEach((x) => (x.State = RowState.NoChange));
      this.detail.dataList = this.model.SellVoucherDetailList;
      this.cd.markForCheck();
      this.detail.cd.markForCheck();
    }
    if (this.detail && !this.isNewRow) this.detail.cancelHandler();

    this.setColumnAttribute();
    if (!this.isNewRow && this.model?.VoucherKindId > 0) this.setReferenceToVoucherKind();

    if (this.detail) {
      this.detail.dataList = this.model?.SellVoucherDetailList ?? [];
      this.detail.ngOnInit();
    }
    setTimeout(() => {
      if (this.detail) {
        this.detail.dataList.forEach((x) => {
          if (x.Id > 0) x.State = RowState.NoChange;
        });
      }
      this.setAllUnTouched();
    }, 100);
  }
  setMaxCode() {
    if (!this.isNewRow || this.maxCodeLoading) return;

    this.maxCodeLoading = true;
    if (this.currentFiscalYear) {
      var fiscalYearId = this.currentFiscalYear.Id;
      this.httpCommonService
        .get(this.apiName + "/" + this.VoucherKind.VoucherKindId + "/" + fiscalYearId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            if (!this.model) this.model = <SellVoucherHeader>{};
            if (data && data["VoucherNumber"]) {
              this.model["VoucherNo"] = data["VoucherNumber"] as number;
              if (this.currentVoucherKind && this.currentVoucherKind.ToDayDate) {
                this.model["VoucherDate"] = new Date();
              } else this.model["VoucherDate"] = data["VoucherDate"] as Date;
              if (!this.formGroup) {
                this.setdefault();
                this.setFormGroup(this.model);
              } else {
                this.setValue("VoucherNo", data["VoucherNumber"] as number);
                this.setValue("VoucherDate", this.model["VoucherDate"]);
              }
            }
            this.maxCodeLoading = false;
          },
          (error) => (this.maxCodeLoading = false)
        );
    } else {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          var fiscalYearId = x.Id;
          this.httpCommonService
            .getMaxCodeWithParameter(this.apiName, this.VoucherKind.VoucherKindId, fiscalYearId, this.model.WarehouseId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data && data["VoucherNumber"]) {
                  this.model["VoucherNo"] = data["VoucherNumber"] as number;
                  if (this.currentVoucherKind && this.currentVoucherKind.ToDayDate) this.model["VoucherDate"] = new Date();
                  else this.model["VoucherDate"] = data["VoucherDate"] as Date;
                  if (!this.formGroup) {
                    this.setdefault();
                    this.setFormGroup(this.model);
                  } else {
                    this.setValue("VoucherNo", data["VoucherNumber"] as number);
                    this.setValue("VoucherDate", data["VoucherDate"] as Date);
                  }
                }
                this.maxCodeLoading = false;
              },
              (error) => (this.maxCodeLoading = false)
            );
        }
      });
    }
  }
  onChange($event) {
    if ($event && $event?.name === "VoucherDate" && this.formGroup?.get("VoucherDate")?.value) {
      if (
        this.formGroup?.get("SellkindId")?.value &&
        this.formGroup?.get("CustomerId")?.value &&
        new Date(this.formGroup?.get("VoucherDate")?.value).getTime() != new Date(this.model.VoucherDate).getTime() &&
        this.model.SellVoucherDetailList.length > 1
      ) {
        if (this.HasPricelist === true && this.model.SellVoucherDetailList.some((x) => x.State !== RowState.Delete && x.State !== RowState.Detached))
          this.sts.showDialog("مايل به تغير قيمت هستيد؟ ", "توجه", DialogType.confirm, () => this.ResetPriceUnit());
        this.model.VoucherDate = this.formGroup?.get("VoucherDate")?.value;
      }
    }
    if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Warehouse")) {
      this.model.WarehouseId = $event.data.Id;
      this.model.WarehouseCode = $event.data.Code;
      this.model.WarehouseTitle = $event.data.Title;
      this.setValue("WarehouseId", this.model.WarehouseId);
      this.setValue("WarehouseCode", this.model.WarehouseCode);
      this.setValue("WarehouseTitle", this.model.WarehouseTitle);
    }
    if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("SellCustomer/GetPagining")) {
      this.model.CustomerGroupId = $event.data.CustomerGroupId;
      this.setValue("CustomerGroupId", this.model.CustomerGroupId);
      this.SetDeliveryPlace($event.data.CustomerId);
      if (
        this.formGroup?.get("SellkindId")?.value &&
        this.formGroup?.get("CustomerId")?.value != this.model.CustomerId &&
        this.formGroup?.get("VoucherDate")?.value &&
        this.model.SellVoucherDetailList.length > 1
      ) {
        if (this.HasPricelist === true && this.model.SellVoucherDetailList.some((x) => x.State !== RowState.Delete && x.State !== RowState.Detached))
          this.sts.showDialog("مايل به تغير قيمت هستيد؟ ", "توجه", DialogType.confirm, () => this.ResetPriceUnit());
        this.model.CustomerId = this.formGroup?.get("CustomerId")?.value;
      }
    }
    if (
      $event.apiName &&
      $event.data &&
      $event.data.Id &&
      $event.apiName.includes("SellKind") &&
      this.formGroup?.get("CustomerId")?.value != this.model.CustomerId &&
      this.formGroup?.get("VoucherDate")?.value &&
      this.model.StatusKindCode <= SellStatusKind.Registered
    ) {
      if (this.formGroup?.get("SellkindId")?.value !== this.model.SellkindId && this.model.SellVoucherDetailList.length > 1) {
        if (this.HasPricelist === true && this.model.SellVoucherDetailList.some((x) => x.State !== RowState.Delete && x.State !== RowState.Detached))
          this.sts.showDialog("مايل به تغير قيمت هستيد؟ ", "توجه", DialogType.confirm, () => this.ResetPriceUnit());
      }
      this.model.SellkindId = this.formGroup?.get("SellkindId")?.value;
    }
    this.isValid();
  }

  setCurrentVoucherKind() {
    if (!this.VoucherKind?.VoucherKindId) return;
    this.httpCommonService
      .getItem<InvVoucherKind>("InvVoucherKind", this.VoucherKind?.VoucherKindId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (this.VoucherKind?.VoucherKindId && !this.formGroup?.get("VoucherKindId")!.value)
            this.setValue("VoucherKindId", this.VoucherKind?.VoucherKindId);
          this.currentVoucherKind = Object.assign({}, data as InvVoucherKind);
          this.model.Invoicecredit = this.currentVoucherKind?.Invoicecredit;
          if (!this.formGroup?.get("Invoicecredit")!.value) this.setValue("Invoicecredit", this.currentVoucherKind?.Invoicecredit);
          this.model.VoucherKindId = this.currentVoucherKind?.Id;
          this.model.VoucherKindCode = this.currentVoucherKind?.Code;
          this.setValue("VoucherKindCode", this.currentVoucherKind?.Code);
          if (this.currentVoucherKind?.DefaultSellKindId && !this.formGroup?.get("SellkindId")!.value)
            this.setValue("SellkindId", this.currentVoucherKind?.DefaultSellKindId);
          if (this.currentVoucherKind.DefaultWarehouseId && !this.formGroup?.get("WarehouseId")!.value)
            this.setValue("WarehouseId", this.currentVoucherKind?.DefaultWarehouseId);
          if (this._id && this.model.VoucherNo) {
            this.label = data.Title + `(${this.model.VoucherNo})`;
            this.tabsservice.setTabTitle(this._id.metadata.id, this.getFormTitle());
          }
          this.setValue("VoucherKindCode", this.currentVoucherKind?.Code);
          if (this.ShowStockAmount) this.setStockInfoColumns();
          if (this.hasReference) this.setReferenceVoucherColumns();
          this.setMaxCode();
          this.setColumnAttribute();
          this.addControl();
          setTimeout(() => this.cd.markForCheck(), 50);
        },
        (error) => this.getFailedHelper(error)
      );
  }
  isNoValidForEdit() {
    let StatusKindCode: number = SellStatusKind.Confirmed;
    return (!this.isNewRow && this.model && this.model?.StatusKindCode >= StatusKindCode) || this.model?.HasReferencedVoucherTo;
  }
  setDetaiLedgerVisble() {
    this.orignalColumns.forEach((x) => {
      if (x.name === "DetailLedger1Id") x.formVisible = this.detailLedgerLevel >= 1;
      if (x.name === "DetailLedger2Id") x.formVisible = this.detailLedgerLevel >= 2;
      if (x.name === "DetailLedger3Id") x.formVisible = this.detailLedgerLevel >= 3;
      if (x.name === "DetailLedger4Id") x.formVisible = this.detailLedgerLevel >= 4;
      if (x.name === "DetailLedger5Id") x.formVisible = this.detailLedgerLevel >= 5;
      if (x.name === "DetailLedger6Id") x.formVisible = this.detailLedgerLevel >= 6;
      if (x.name === "DetailLedger7Id") x.formVisible = this.detailLedgerLevel >= 7;

      if (x.name === "SellDetailLedger1Id") x.formVisible = this.detailLedgerLevel >= 1;
      if (x.name === "SellDetailLedger2Id") x.formVisible = this.detailLedgerLevel >= 2;
      if (x.name === "SellDetailLedger3Id") x.formVisible = this.detailLedgerLevel >= 3;
      if (x.name === "SellDetailLedger4Id") x.formVisible = this.detailLedgerLevel >= 4;
      if (x.name === "SellDetailLedger5Id") x.formVisible = this.detailLedgerLevel >= 5;
      if (x.name === "SellDetailLedger6Id") x.formVisible = this.detailLedgerLevel >= 6;
      if (x.name === "SellDetailLedger7Id") x.formVisible = this.detailLedgerLevel >= 7;
    });
  }
  setColumnAttribute() {
    try {
      this.setLoaclColumns();
      this.setDetaiLedgerVisble();
      this.orignalColumns.forEach((x) => {
        if (x.name === "WarehouseTransferId") {
          if (this.currentVoucherKind && this.currentVoucherKind.HasWarehouseTransfer) {
            x.disabled = !this.currentVoucherKind.HasWarehouseTransfer;
            if (this.currentVoucherKind.HasWarehouseTransfer) x.required = this.currentVoucherKind.HasWarehouseTransfer;
            if (this.currentVoucherKind.OpositePartyWarehouseCaption) x.label = this.currentVoucherKind.OpositePartyWarehouseCaption;
          } else {
            x.disabled = true;
            x.required = false;
          }
        }
        if (x.name === "VoucherDate") {
          if (this.currentVoucherKind) {
            x.disabled = this.currentVoucherKind.HasCheckVoucherDate;
            if (this.formGroup && this.formGroup.get(x.name)) {
              if (x.disabled) this.formGroup.get(x.name).disable();
              else this.formGroup.get(x.name).enable();
              this.formGroup.get(x.name).updateValueAndValidity();
            }
          }
        }
        if (x.name === "WarehouseId") {
          if (this.currentVoucherKind) {
            x.disabled = !(this.currentVoucherKind.ShowWarehouse && this.currentVoucherKind.WarehouseIsInHeader);
            if (this.currentVoucherKind.ShowWarehouse && this.currentVoucherKind.WarehouseIsInHeader)
              x.required = this.currentVoucherKind.ShowWarehouse;
            if (this.currentVoucherKind.WarehouseCaption) x.label = this.currentVoucherKind.WarehouseCaption;
          } else {
            x.disabled = true;
            x.required = false;
          }
        }
        if (x.name === "SubLedgerId") {
          if (this.currentVoucherKind) {
            x.disabled = !this.currentVoucherKind.HasSubledger;
          } else x.disabled = true;
        }
        if (x.name === "CustomerId") {
          if (this.currentVoucherKind) {
            x.disabled = !this.currentVoucherKind.HasOpositeParty;
            if (this.currentVoucherKind?.HasOpositeParty) x.label = this.currentVoucherKind.OpositePartyCaption;
            x.required = this.currentVoucherKind.HasOpositeParty;
          } else {
            x.disabled = true;
            x.required = false;
          }
        }
        if (x.name === "ReceiptDate" || x.name === "ReceiptDays") {
          if (this.currentVoucherKind) x.disabled = !this.currentVoucherKind.HasReceiptDate;
          else x.disabled = true;
        }
        if (x.name === "Invoicecredit") {
          if (this.currentVoucherKind) x.disabled = !this.currentVoucherKind.HasChangeInvoicecredit;
          else x.disabled = true;
        }
        if (x.name === "ReferenceVoucherKindId") {
          if (this.hasReference) {
            x.disabled = !this.hasReference;
            if (this.hasReference) x.required = this.hasReferenceRequired;
            if (this.hasReference) {
              this.setReferenceVoucherKind();
              let vk = this.currentVoucherKind.ReferenceVoucherKinds.find((vk) => vk.IsDefault);
              if (vk) {
                this.model.ReferenceVoucherKindId = vk.ReferenceVoucherKindId;
                this.setValue("ReferenceVoucherKindId", vk.ReferenceVoucherKindId);
              }
            }
          } else {
            x.disabled = true;
            x.required = false;
          }
        }
        if (x.name === "SlaveNo") {
          if (this.currentVoucherKind) {
            x.disabled = !this.currentVoucherKind.HasSlaveNo;
            if (this.currentVoucherKind.SlaveNoCaption) x.label = this.currentVoucherKind.SlaveNoCaption;
          } else x.disabled = true;
        }
      });
      if (this.isNoValidForEdit()) {
        this.orignalColumns.forEach((x) => {
          if (
            (!x.name.includes("DetailLedger1") &&
              !x.name.includes("DetailLedger2") &&
              !x.name.includes("DetailLedger3") &&
              !x.name.includes("SubLedger") &&
              !x.name.includes("DetailLedger4") &&
              !x.name.includes("DetailLedger5")) ||
            this.model.StatusKindCode === InvStatusKind.AccountRegistered
          )
            x.disabled = true;
          else x.disabled = false;
          if (this.formGroup && this.formGroup.get(x.name)) {
            if (x.disabled) this.formGroup.get(x.name).disable();
            else this.formGroup.get(x.name).enable();
            this.formGroup.get(x.name).updateValueAndValidity();
          }
        });
      } else {
        this.orignalColumns.forEach((x) => {
          if (this.formGroup && this.formGroup.get(x.name)) {
            if (x.disabled) this.formGroup.get(x.name).disable();
            else this.formGroup.get(x.name).enable();
            this.formGroup.get(x.name).updateValueAndValidity();
          }
        });
      }
      if (this.formGroup) this.formGroup.updateValueAndValidity();
      if (this.currentVoucherKind && this.model) {
        this.label = this.currentVoucherKind.Title + `(${this.model?.VoucherNo})`;
        if (this._id) this.tabsservice.setTabTitle(this._id.metadata.id, this.getFormTitle());
      }
      if (this.formGroup) this.formGroup.updateValueAndValidity();
      this.cd.markForCheck();
      this.SellVoucherDetailColumns = this.getDetailControlModels("SellVoucherDetailList");
      this.DiscountColumns = this.getcolumns("Discount");
    } catch (e) {
      console.log(e);
    }
  }
  setReferenceVoucherKind() {
    this.httpCommonService
      .get("InvVoucherKind/ReadLookUp")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          let vk = (data as InvVoucherKind[]).filter((x) =>
            this.currentVoucherKind.ReferenceVoucherKinds.some((vk) => vk.ReferenceVoucherKindId === x.Id)
          );
          this.selectorService.setDataList("ReferenceVoucherKindId", vk);
        },
        (error) => this.getFailedHelper(error)
      );
  }
  async changeReferenceToVoucherKind(id: number) {
    let vk = this.ReferenceToVoucherKinds.find((x) => x.Id === id);
    if (!vk) return;
    let rvk: ReferenceVoucherKind = <ReferenceVoucherKind>{ InvVoucherKindId: vk.Id };
    if (!this.model.HasReferencedVoucherTo && vk) await this.CreateVoucherKindReferencedTo(rvk);
    else this.erroremessage = "برای این سند قبلا معطوف صادر شده است.";
  }
  setReferenceToVoucherKind() {
    this.httpCommonService
      .get("InvVoucherKind/GetReferenceVoucherKind/?id=" + this.currentVoucherKind?.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: InvVoucherKind[]) => {
          if (data && data.length > 0) {
            this.ReferenceToVoucherKinds = data;
            this.CurrentReferenceToVoucherKindId = data[0].Id;
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }

  setDefaultValues() {
    this.orignalColumns.forEach((x) => {
      if (x.controlType === FormControlTypes.checkbox && this.model[x.name] === undefined) this.model[x.name] = false;
      if (x.name === "VoucherDate") x.disabled = this.currentVoucherKind && this.currentVoucherKind.HasCheckVoucherDate;
    });
  }
  addControl() {
    this.isOkForLoad = false;
    this.selectorService.setIsFloat("TotalDiscount", true);
    if (this.formGroup) this.setSummery();
    if (this.currentVoucherKind?.HasSubledger && this.currentVoucherKind?.DefaultSubLedgerId && !this.model?.SubLedgerId)
      this.setValue("SubLedgerId", this.currentVoucherKind?.DefaultSubLedgerId);

    if (!this.model.VoucherDate && this.currentVoucherKind && this.currentVoucherKind.ToDayDate) this.model.VoucherDate = new Date();

    if (this.currentVoucherKind !== undefined) this.isOkForLoad = true;
    if (this.formGroup.controls["VoucherDate"]) this.formGroup.controls["VoucherDate"].valueChanges.subscribe((x) => this.isValid());
    if (this.model?.SellVoucherDetailList && this.model?.SellVoucherDetailList?.length > 0) {
      this.setValue("WarehouseId", this.model.SellVoucherDetailList[0].WarehouseId);
    }

    this.hasPriceRefresh =
      this.currentVoucherKind?.HasPriceRefresh &&
      (this.isNewRow || this.model.StatusKindCode == SellStatusKind.Registered) &&
      !this.missetup.getboolean("INV", "CostBasedPricing");
    this.setValue("ConsumedCredit", this.model?.Customer?.ConsumedCredit);
    this.setValue("DocumentCredit", this.model?.Customer?.DocumentCredit);
    this.setValue("ConsumedCreditRemain", this.model?.Customer?.ConsumedCreditRemain);
    this.setValue("DocumentCreditRemain", this.model?.Customer?.DocumentCreditRemain);
    this.setValue("CustomerRemain", this.model?.Customer?.CustomerRemain);
    this.cd.markForCheck();
    if (this.formGroup) {
      this.formGroup.get("ReceiptDays").valueChanges.subscribe((x) => {
        if (this.valueIsSetting !== true && this.formGroup?.get("SellkindId")?.value && this.formGroup?.get("VoucherDate")?.value) {
          this.valueIsSetting = true;
          this.model.ReceiptDate = new Date(this.formGroup?.get("VoucherDate")?.value);
          this.setValue("ReceiptDate", new Date(this.model.ReceiptDate.setDate(this.formGroup?.get("VoucherDate")?.value.getDate() + (x ?? 0))));
          this.cd.markForCheck();
          this.valueIsSetting = false;
        }
      });
      this.formGroup.get("ReceiptDate").valueChanges.subscribe((x) => {
        if (this.valueIsSetting !== true && this.formGroup?.get("SellkindId")?.value && this.formGroup?.get("VoucherDate")?.value) {
          this.valueIsSetting = true;
          this.model.ReceiptDate = x ?? new Date(this.formGroup?.get("VoucherDate")?.value);
          this.model.VoucherDate = new Date(this.formGroup?.get("VoucherDate")?.value);
          this.model.ReceiptDays = Math.floor(
            (Date.UTC(this.model.ReceiptDate.getFullYear(), this.model.ReceiptDate.getMonth(), this.model.ReceiptDate.getDate()) -
              Date.UTC(this.model.VoucherDate.getFullYear(), this.model.VoucherDate.getMonth(), this.model.VoucherDate.getDate())) /
              (1000 * 60 * 60 * 24)
          );
          this.setValue("ReceiptDays", this.model.ReceiptDays);
          this.cd.markForCheck();
          this.valueIsSetting = false;
        }
      });
    }
  }

  async onValueChanges($event) {
    if (this.detail && this.detail?.dataList) this.model.SellVoucherDetailList = this.detail?.dataList;
    if (!this.isloading && this.ShowStockAmount && $event && ($event.UnitId || $event.GoodsId)) {
      this.isloading = true;
      let goodsId: number = $event.GoodsId ? $event.GoodsId : $event.Id;
      var filters: GridFilter[] = [];

      if (this.dataList && this.dataList.length > 0) this.filterdDataList = this.dataList.filter((f) => f.GoodsId === goodsId);
      filters.push({ Filed: "FiscalYearId", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: this.model.FiscalYearId, Logic: "and" });
      let voucherdate: Date = this.formGroup.value.VoucherDate;
      if (isNullOrUndefined(voucherdate)) {
        if (!this.model.VoucherDate) voucherdate = new Date();
        else voucherdate = this.model.VoucherDate;
      }
      filters.push({ Filed: "VoucherDate", Operator: "lte", Type: "F", Skip: 0, Take: 20, Value: voucherdate, Logic: "and" });
      var GoodsIds: number[] = [];
      this.model.SellVoucherDetailList.forEach((x) => {
        if (!GoodsIds.some((g) => g === x.GoodsId)) GoodsIds.push(x.GoodsId);
      });
      if (goodsId && !GoodsIds.some((g) => g === goodsId)) GoodsIds.push(goodsId);
      filters.push({ Filed: "GoodsIds", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: GoodsIds, Logic: "and" });
      await this.httpCommonService
        .create(`InvVoucherHeader/GetCaredx`, filters)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x: PagingDataResult<StockInfo>) => {
            this.isloading = false;
            this.dataList = x.Data as [];
            this.filterdDataList = this.dataList.filter((f) => f.GoodsId === goodsId);
          },
          (error) => {
            this.isloading = false;
          }
        );
    }

    this.setSummery();
    if (this.model.StatusKindCode >= SellStatusKind.Confirmed) return;
    if (this.ShowStockAmount && $event && $event.GoodsId) {
      this.setGoodsValidation($event);
    }
    if ($event.GoodsId) this.ResetPriceUnit();
    else await this.SetPriceUnit(false, undefined);
    if (!this.isValidating) this.isValid();
  }
  SetDeliveryPlace(CustomerId: number) {
    this.httpCommonService
      .getItem(`PeopleInfo/GetPeopleInfoDetails`, CustomerId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x: PeopleInfo) => {
          if (x && x.PeopleInfoAddresss) {
            if (x.PeopleInfoAddresss?.length == 1) {
              this.model.DeliveryPlaceId = x.PeopleInfoAddresss[0].Id;
              this.model.DeliveryPlaceTitle = x.PeopleInfoAddresss[0].Address;
              this.setValue("DeliveryPlaceId", this.model.DeliveryPlaceId);
            }
            this.selectorService.setDataList("DeliveryPlaceId", x.PeopleInfoAddresss);
          }
        },
        (error) => {
          this.isloading = false;
          this.getFailedHelper(error);
        }
      );
  }
  onValueChangeByApiName($event) {
    if ($event && $event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Warehouse")) {
      this.model.WarehouseTitle = $event.data.Title;
      this.model.WarehouseCode = $event.data.Code;
      this.setValue("WarehouseTitle", $event.data.Title);
      this.setValue("WarehouseCode", $event.data.Code);
    }
    this.model.SellVoucherDetailList.filter(
      (x) => x.State !== RowState.Delete && x.State !== RowState.Detached && x.State !== RowState.SoftDelete
    ).forEach((x) => {
      this.onValueChanges(x);
    });
    if (!this.isValidating) this.isValid();
    else if ($event && $event.apiName && $event.data && $event.data.Id && $event.apiName.includes("DetailLedger")) {
      this.isValid();
    }
    this.isValidating = false;
  }
  setGoodsValidation(event: SellVoucherDetail) {
    this.goodsError = false;
    if (event.ReferenceId && event.ReferenceId > 0 && event.BaseAmount > 0) {
      if (event.Amount > event.BaseAmount && !this.currentVoucherKind?.BasedOnBOM) {
        this.goodsError = true;
        this.erroremessage = `برای کالای ${event.GoodsTitle} با کد(${event.GoodsCode})  در انبار ${event.WarehouseTitle} مقدار نمی تواند از مقدارمبنا بیشتر باشد.`;
      }
    }
    if (this.formGroup.value.WarehouseId) {
      if (this.currentVoucherKind && this.currentVoucherKind.IncrementalKindCode === IncrementalKind.Decrement && event.MainAmount) {
        let stockinfo = this.dataList.find((x) => x.WarehouseId === this.formGroup.value.WarehouseId && x.GoodsId === event.GoodsId);
        if (
          this.currentVoucherKind.IncrementalKindCode === IncrementalKind.Decrement &&
          (!stockinfo || stockinfo.StockAmount + event.OrignalMainAmount - event.MainAmount < 0)
        ) {
          this.goodsError = true;
          event.HasError = true;
          this.erroremessage = `برای کالای ${event.GoodsTitle} با کد(${event.GoodsCode})  در انبار ${event.WarehouseTitle} موجودی کافی وجود ندارد.`;
        }
      }
    }
  }
  setSummery() {
    this.cd.markForCheck();
    if (this.model === undefined || this.model.SellVoucherDetailList === undefined) return;
    if (!this.formGroup.controls["TotalPrice"])
      this.formGroup.addControl("TotalPrice", new UntypedFormControl(this.model.SellVoucherDetailList?.getSumWithKey("Price")));
    else this.formGroup.controls["TotalPrice"].setValue(this.model.SellVoucherDetailList?.getSumWithKey("Price"));

    if (!this.formGroup.controls["SumPrice"])
      this.formGroup.addControl(
        "SumPrice",
        new UntypedFormControl(
          this.model.SellVoucherDetailList?.getSumWithKey("TotalPrice") -
            (this.formGroup?.get("TotalDeduction")?.value ?? 0) +
            (this.formGroup?.get("TotalSurplusage")?.value ?? 0)
        )
      );
    else
      this.formGroup.controls["SumPrice"].setValue(
        this.model.SellVoucherDetailList?.getSumWithKey("TotalPrice") -
          (this.formGroup?.get("TotalDeduction")?.value ?? 0) +
          (this.formGroup?.get("TotalSurplusage")?.value ?? 0)
      );

    if (this.hasDiscount) {
      if (!this.formGroup.controls["DiscountAmount"])
        this.formGroup.addControl("DiscountAmount", new UntypedFormControl(this.model.SellVoucherDetailList?.getSumWithKey("DiscountAmount")));
      else this.formGroup.controls["DiscountAmount"].setValue(this.model.SellVoucherDetailList?.getSumWithKey("DiscountAmount"));

      if (!this.formGroup.controls["SumDeduction"])
        this.formGroup.addControl(
          "SumDeduction",
          new UntypedFormControl(this.model.SellVoucherDetailList?.getSumWithKey("Deduction") + (this.formGroup?.get("TotalDeduction")?.value ?? 0))
        );
      else
        this.formGroup.controls["SumDeduction"].setValue(
          this.model.SellVoucherDetailList?.getSumWithKey("Deduction") + (this.formGroup?.get("TotalDeduction")?.value ?? 0)
        );
    }
    if (this.hasTaxDuty) {
      if (!this.formGroup.controls["Tax"])
        this.formGroup.addControl("Tax", new UntypedFormControl(this.model.SellVoucherDetailList?.getSumWithKey("Tax")));
      else this.formGroup.controls["Tax"].setValue(this.model.SellVoucherDetailList?.getSumWithKey("Tax"));
    }

    if (!this.formGroup.controls["SumSurplusage"])
      this.formGroup.addControl(
        "SumSurplusage",
        new UntypedFormControl(this.model.SellVoucherDetailList?.getSumWithKey("Surplusage") + (this.formGroup?.get("TotalSurplusage")?.value ?? 0))
      );
    else
      this.formGroup.controls["SumSurplusage"].setValue(
        this.model.SellVoucherDetailList?.getSumWithKey("Surplusage") + (this.formGroup?.get("TotalSurplusage")?.value ?? 0)
      );
    if (!this.formGroup.controls["PaymentValue"]) this.formGroup.addControl("PaymentValue", new UntypedFormControl(0));
    else this.formGroup.controls["PaymentValue"].setValue(0);
    if (!this.formGroup.controls["RemainValue"]) this.formGroup.addControl("RemainValue", new UntypedFormControl(0));
    else this.formGroup.controls["RemainValue"].setValue(0);
    this.formGroup.markAllAsTouched();
    this.cd.markForCheck();
  }
  isValueValid() {
    if (
      this.formGroup.controls["TransportPrice"] &&
      this.formGroup.controls["TransportPrice"].value &&
      this.formGroup.controls["TransportPrice"].value < 0
    ) {
      this.erroremessage = `کرایه نمی تواند منفی باشد.`;
    }
    if (
      this.formGroup.controls["TransportTax"] &&
      this.formGroup.controls["TransportTax"].value &&
      this.formGroup.controls["TransportTax"].value < 0
    ) {
      this.erroremessage = `مالیات کرایه نمی تواند منفی باشد.`;
    }
  }
  isValid() {
    let flag: boolean = true;
    if (this.isValidating) return;
    if (!this.formGroup?.valid && !this.formGroup.value.StatusKindId) this.setStatusKind();
    if (!this.goodsError) this.erroremessage = undefined;
    else flag = false;
    if (flag && this.currentVoucherKind?.HasCredit === true && !this.CheckCredit()) flag = false;
    if (flag) this.isValueValid();
    if (
      (flag &&
        new Date(this.formGroup.controls["VoucherDate"].value).setHours(0, 0, 0, 0) <
          new Date(this.accountService.authService.currentFiscalYear.StartDate).setHours(0, 0, 0, 0)) ||
      new Date(this.formGroup.controls["VoucherDate"].value).setHours(0, 0, 0, 0) >
        new Date(this.accountService.authService.currentFiscalYear.EndDate).setHours(0, 0, 0, 0)
    ) {
      this.erroremessage = "تاریخ سند باید در محدوده سال مالی باشد.";
      return false;
    }
    if (flag && this.currentVoucherKind && this.currentVoucherKind.HasCheckVoucherDate && this.isNewRow) {
      if (new Date(this.formGroup.controls["VoucherDate"].value).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
        this.erroremessage = "تاریخ سند نمی تواند کوچکتر از تاریخ جاری باشد.";
        flag = false;
      }
    }

    if (flag && !this.formGroup.controls["FiscalYearId"].value && !this.accountService.authService.currentFiscalYear) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) this.setValue("FiscalYearId", x.Id);
      });
    }
    if (this.currentVoucherKind && this.currentVoucherKind?.HasOpositeParty && flag) {
      if (!this.formGroup?.controls["CustomerId"]?.value) {
        this.erroremessage = `انتخاب  ${this.getColumnCaption("CustomerId")} الزامی است.`;
        flag = false;
      }
    }
    if (this.erroremessage && flag) flag = false;
    if (flag) {
      if (
        this.model.SellVoucherDetailList &&
        this.model.SellVoucherDetailList.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).length > 0
      ) {
        if (!this.formGroup?.valid) {
          let list = this.setFormGroupErrors();
        }
        flag = this.formGroup?.valid || this.formGroup.status === "DISABLED";
      } else {
        this.erroremessage = "برای سند هیچ قلمی وارد نشده است.";
        flag = false;
      }

      if (
        (flag && this.currentVoucherKind?.AutoFocusedDocumentIssuance && this.currentVoucherKind?.AutoCreateVoucherKindId !== undefined) ||
        this.currentVoucherKind?.HasAutoConfirm
      ) {
        if (
          this.currentVoucherKind?.HasWarehouseTransfer &&
          this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.IsPurchaseInvoice &&
          this.currentVoucherKind?.IncrementalKindCode === 1 &&
          this.model.SellVoucherDetailList.some((x) => x.State !== RowState.Detached && x.State !== RowState.Delete && x.UnitPrice === 0)
        ) {
          this.erroremessage = "بعلت اقلام بدون قیمت سند قابل تائید نیست.";
          flag = false;
        }
      }
      if (flag) {
        if (
          this.model.SellVoucherDetailList.some((x) => x.State !== RowState.Detached && x.State !== RowState.Delete && (!x.Amount || x.Amount <= 0))
        ) {
          this.erroremessage = "مقدار نمی تواند خالی باشد.";
          flag = false;
        }
      }
      if (
        flag &&
        this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.IsPurchaseInvoice &&
        this.model?.SellVoucherDetailList &&
        this.model.SellVoucherDetailList.some((x) => !x.UnitPrice || x.UnitPrice <= 0)
      ) {
        this.erroremessage = "تکمیل فی اقلام الزامی است.";
        flag = false;
      }
      if (flag) {
        this.isValidating = true;
        this.onValueChangeByApiName(null);
        this.isValidating = false;
        flag = !this.erroremessage;
      }
    }
    return flag;
  }
  getFilters(columnsName: string, searchValue: string, skip: number, take: number) {
    var filters: GridFilter[] = [];
    const columns = columnsName.split(",");
    columns.forEach((x) => {
      {
        if (x !== "Id")
          filters.push({ Filed: x, Operator: "contains", Type: "F", Skip: skip, Take: take, Value: searchValue.toString(), Logic: "or" });
        else if (isNumber(searchValue))
          filters.push({ Filed: x, Operator: "eq", Type: "F", Skip: skip, Take: take, Value: Number(searchValue), Logic: "or" });
      }
    });
    return filters;
  }

  beforupdate() {
    this.CreatedVoucherKindReferencedToHasError = false;
    this.CreatingAccVoucherHasError = false;
    if (this.detail) {
      if (this.detail.formGroup && this.detail?.formGroup?.valid) this.detail.saveCurrent();
      else this.detail.cancelHandler();
    }
    if (this.model.AccVoucherFixNumber > 0) return;

    if (this.currentVoucherKind.ShowWarehouse && this.currentVoucherKind.WarehouseIsInHeader) {
      this.model.SellVoucherDetailList.forEach((x) => {
        if (x.WarehouseId !== this.model.WarehouseId) {
          x.WarehouseId = this.model.WarehouseId;
          x.WarehouseCode = this.model.WarehouseCode;
          x.WarehouseTitle = this.model.WarehouseTitle;
          if (x.State !== RowState.Delete && x.State !== RowState.Detached) x.State = RowState.Modify;
        }
      });
    }
    if (this.model.SellVoucherDetailList !== undefined && this.model.SellVoucherDetailList.length > 0) {
      this.model.SellVoucherDetailList.forEach((x) => {
        if (x.State !== RowState.Detached && x.State !== RowState.Delete) this.setGoodsValidation(x);
      });
    }

    if (
      (this.currentVoucherKind.HasAutoConfirm ||
        this.currentVoucherKind.HasJournalVoucherAuto ||
        this.currentVoucherKind.AutoFocusedDocumentIssuance) &&
      this.model.StatusKindCode != InvStatusKind.Confirmed
    ) {
      this.lookupservice
        .getLookupbyCode("INV", "StatusKind", InvStatusKind.Confirmed)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            this.model.StatusKindId = x.Id;
            this.model.StatusKindCode = x.Code;
            this.model.StatusKindTitle = x.Title;
            this.setValue("StatusKindId", x.Id);
            this.setValue("StatusKindCode", x.Code);
            this.setValue("StatusKindTitle", x.Title);

            if (this.model.StatusKindCode === InvStatusKind.Confirmed) this.confirmLabel = "برگشت از تایید";
            else this.confirmLabel = "تایید سند";
          }
        });
    }
    this.model.SellVoucherDetailList = this.model?.SellVoucherDetailList?.filter((x) => x.State !== RowState.Detached);
    if (this.model.SellVoucherDetailList && this.model.SellVoucherDetailList.length > 0) {
      this.model.SellVoucherDetailList.forEach((x) => {
        if (x.InvReferenceId > 0) x.ReferenceId = undefined;
      });
      if (!this.formGroup.controls["SellVoucherDetailList"])
        this.formGroup.addControl("SellVoucherDetailList", new UntypedFormControl(this.model.SellVoucherDetailList));
      else this.formGroup.controls["SellVoucherDetailList"].setValue(this.model.SellVoucherDetailList);
    } else this.erroremessage = "برای سند هیچ قلمی وارد نشده است.";

    if (
      (this.currentVoucherKind.AutoFocusedDocumentIssuance && this.currentVoucherKind.AutoCreateVoucherKindId !== undefined) ||
      this.currentVoucherKind?.HasAutoConfirm
    ) {
      if (this.model.StatusKindCode <= InvStatusKind.Registered) this.setConfirmStatusKind();
    }
  }

  setReferenceVoucherColumns() {
    this.httpCommonService
      .get("InvVoucherHeader/GetReferenceVoucherInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.selectorService.setColumns("ReferenceId", data as []);
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }
  setStockInfoColumns() {
    this.httpCommonService
      .get("InvVoucherHeader/GetStockInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.StockInfoColumns = (data as form_control[]).filter((f) => (!f.areaName || f.areaName === "default") && f.listVisible);
            this.StockInfoColumns = this.StockInfoColumns.sort((a, b) => a.order - b.order);
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }
  GetVoucherKind(InvVoucherKindId: number) {
    return <InvVoucherKind>{};
  }
  async CreateVoucherKindReferencedTo(rvk: ReferenceVoucherKind) {
    if (rvk === null || rvk === undefined) {
      if (this.currentVoucherKind.AutoCreateVoucherKindId !== undefined) {
        await this.httpCommonService
          .getItem<InvVoucherKind>("InvVoucherKind", this.currentVoucherKind.AutoCreateVoucherKindId)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            async (data) => {
              if (data !== null) await this.CreateInvVoucherReferencedTo(data);
            },
            (error) => this.getFailedHelper(error)
          );
      }
    }
    if (rvk !== null && rvk !== undefined) {
      await this.httpCommonService
        .getItem<InvVoucherKind>("InvVoucherKind", rvk.InvVoucherKindId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          async (data) => {
            if (data !== null && data.IsWarehouse) await this.CreateInvVoucherReferencedTo(data);
          },
          (error) => this.getFailedHelper(error)
        );
    }
  }
  async saveReferenceVoucher(model: any) {
    if (this.CreatedVoucherKindReferencedTo === true) return;
    this.CreatedVoucherKindReferencedTo = true;
    if (!this.model.HasReferencedVoucherTo) {
      this.splashFormService.openDialog("", "در حال صدور سند معطوف");
      let apiName = this.apiName;
      if (model.InvVoucherDetailList && model.InvVoucherDetailList.length > 0) apiName = "InvVoucherHeader";

      await this.httpCommonService
        .create(apiName, model)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          async (row) => {
            this.splashFormService.closeLoading();
            this.tabsservice.tabItemonRefreshData.next(this.apiName);
            await this.ngOnInit();
            this.isRefreshingData = false;
            this.CreatedVoucherKindReferencedTo = false;
            this.sts.showToast("primary", "", "صند معطوف با موفقیت صادر شد.");
          },
          async (error) => {
            await this.ngOnInit();
            this.isRefreshingData = false;
            this.CreatedVoucherKindReferencedTo = false;
            this.currentVoucherKind.AutoFocusedDocumentIssuance = false;
            this.CreatedVoucherKindReferencedToHasError = true;
            //this.saveFailedHelper(error);
            this.splashFormService.closeLoading();
            this.sts.showDialog(` خطا در صدور سند معطوف ${Utilities.getHttpResponseMessage(error)}`, "خطا");
          }
        );
    }
  }
  async CreateInvVoucherReferencedTo(vk: InvVoucherKind) {
    let flag: boolean = true;
    var refVoucher: any;

    if (vk.IsWarehouse === true) refVoucher = <InvVoucherHeader>{};
    else refVoucher = <SellVoucherHeader>{};

    Object.keys(this.model).forEach((key) => {
      refVoucher[key] = this.model[key];
    });
    this.lookupservice
      .getLookupbyCode(vk.IsWarehouse === true ? "INV" : "SELL", "StatusKind", InvStatusKind.Confirmed)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        if (x) {
          refVoucher.StatusKindId = x.Id;
          refVoucher.StatusKindCode = x.Code;
          refVoucher.StatusKindTitle = x.Title;
        }
      });
    if (vk.HasSubledger && vk.DefaultSubLedgerId) refVoucher.SubLedgerId = vk.DefaultSubLedgerId;
    refVoucher.WarehouseId = this.model?.SellVoucherDetailList[0]?.WarehouseId;
    refVoucher.State = RowState.New;
    refVoucher.FiscalYearId = this.model.FiscalYearId;
    refVoucher.Id = 0;
    if (vk.IsWarehouse === true) refVoucher.SellReferenceVoucherId = this.model.Id;
    else refVoucher.ReferenceVoucherId = this.model.Id;
    if (vk.IncrementalKindCode !== IncrementalKind.Decrement) {
      refVoucher.TotalPrice = this.model.TotalPrice;
      refVoucher.TotalDeduction = this.model.TotalDeduction;
      refVoucher.TotalSurplusage = this.model.TotalSurplusage;
    }
    refVoucher.VoucherKindId = vk.Id;
    refVoucher.VoucherKindCode = vk.Code;
    refVoucher.VoucherKindTitle = vk.Title;
    refVoucher.ReceiptDate = this.model.ReceiptDate;
    refVoucher.ReceiptDays = this.model.ReceiptDays;
    refVoucher.ReferenceVoucherKindId = this.currentVoucherKind.Id;
    refVoucher.ReferenceVoucherKindCode = this.currentVoucherKind.Code;
    refVoucher.ReferenceVoucherKindTitle = this.currentVoucherKind.Title;
    refVoucher.VoucherDate = this.model.VoucherDate;
    if (vk.IsWarehouse === true) refVoucher.InvVoucherDetailList = [];
    else refVoucher.SellVoucherDetailList = [];

    this.model.SellVoucherDetailList.forEach((x) => {
      var vd: any;

      if (vk.IsWarehouse === true) vd = <InvVoucherDetail>{};
      else vd = <SellVoucherDetail>{};
      Object.keys(x).forEach((key) => {
        vd[key] = x[key];
      });
      vd.State = RowState.New;
      vd.Id = 0;
      if (vk.IsWarehouse === true) vd.SellReferenceId = x.Id;
      else vd.ReferenceId = x.Id;
      vd.ReferenceCode = this.model.VoucherNo;
      if (vk.IncrementalKindCode === IncrementalKind.Decrement) vd.UnitPrice = 0;
      if (
        (vk.IncrementalKindCode === IncrementalKind.Decrement || vk.ReserveBalance || vk.HasInventoryControl) &&
        this.missetup.getnumber("INV", "NegativeBalance")
      ) {
        let SaleAvailable: boolean = true;
      }
      if (!(vk.FormOperationKindCode || vk.FormOperationKindCode === FormOperationKind.IsReturnPurchaseInvoice)) {
        vd.DiscountAmount = 0;
        vd.DiscountRate = 0;
        vd.Surplusage = 0;
        vd.Deduction = 0;
        vd.Tax = 0;
      }
      if (vk.IsWarehouse === true) refVoucher.InvVoucherDetailList.push(vd);
      else refVoucher.SellVoucherDetailList.push(vd);
    });
    if (!flag) {
      this.sts.showDialog(
        "خطا در صدور سند معطوف.",
        "هشدار",
        DialogType.confirm,
        () => this.closeForm(true),
        () => this.closeForm(false)
      );
    } else await this.saveReferenceVoucher(refVoucher);
  }

  afterupdate() {
    super.afterupdate();
    this.afterDataLoaded.pipe(takeUntil(this.ngUnsubscribe)).subscribe(async (x) => {
      if (this.model.AccVoucherFixNumber > 0) return;
      if (x === true && this.isRefreshingData !== true) {
        this.isRefreshingData = true;
        if (this.currentVoucherKind.AutoFocusedDocumentIssuance && this.currentVoucherKind.AutoCreateVoucherKindId !== undefined) {
          if (
            !this.model.HasReferencedVoucherTo &&
            this.CreatedVoucherKindReferencedTo === false &&
            this.CreatedVoucherKindReferencedToHasError !== true
          )
            await this.CreateVoucherKindReferencedTo(null);
          else this.erroremessage = "برای این سند قبلا معطوف صادر شده است.";
        }

        if (this.currentVoucherKind.HasJournalVoucher === true && this.currentVoucherKind.HasJournalVoucherAuto === true) {
          if (this.model.StatusKindCode !== InvStatusKind.Confirmed) {
            this.lookupservice
              .getLookupbyCode("SELL", "StatusKind", InvStatusKind.Confirmed)
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe((x) => {
                if (x) {
                  this.model.StatusKindId = x.Id;
                  this.model.StatusKindCode = x.Code;
                  this.model.StatusKindTitle = x.Title;
                  if (this.model.StatusKindCode === InvStatusKind.Confirmed) this.confirmLabel = "برگشت از تایید";
                  else this.confirmLabel = "تایید سند";
                }
              });
          }
          let gridFilter: GridFilter[] = [];
          let SellVoucherHeaderIds: number[] = [];
          SellVoucherHeaderIds.push(this.model.Id);
          let filter: GridFilter = {
            Type: "F",
            Filed: "SellVoucherHeaderIds",
            Value: SellVoucherHeaderIds,
            Logic: "and",
            Operator: "eq",
            Skip: 0,
            Take: 0,
          };
          gridFilter.push(filter);
          if (this.CreatingAccVoucherHasError !== true) await this.createAccVoucher(gridFilter);
        }
      }
    });
  }
  async closeForm(flag: boolean = false) {
    if (flag && !this.isNewVoucher) {
      if (this._id?.metadata?.id) {
        this.tabsservice.tabItemonRefreshData.next(this.apiName);
        this.tabsservice.tabItemOnCanClosing.next(this._id?.metadata?.id);
      }
      this.close();
    }
    if (!flag) {
      if (this._id?.metadata?.id) {
        this.tabsservice.tabItemonRefreshData.next(this.apiName);
        this.tabsservice.tabItemOnCanClosing.next(this._id?.metadata?.id);
      }
      this.close();
    }
    if (flag && this.isNewVoucher) {
      this.selectorService.submitted$.next(false);
      this.model = undefined;
      this.currentrow = undefined;
      await this.ngOnInit();
    }
    this.isClosing = false;
  }
  isCloseable() {
    this.selectorService.submitted$.next(false);
    this.formGroup?.markAsUntouched();
    this.currentrow = this.model;
    return false;
  }
  canDeactivate(): boolean | Observable<boolean> {
    if (
      !(
        (this.formGroup && this.formGroup.touched && this.formGroup.dirty) ||
        (this.model?.SellVoucherDetailList?.length > 0 &&
          this.model?.SellVoucherDetailList?.some((x) => x.State === RowState.New || x.State === RowState.Modify))
      )
    )
      return true;
    this.sts.showDialog(
      "شما اطلاعات ذخیره نشده دارید! در صورت خروج اطلاعات از دست خواهد رفت.",
      "هشدار",
      DialogType.confirm,
      () => this.closeForm(true),
      () => this.closeForm(false)
    );
    return false;
  }

  submitButtonDisabled() {
    return this.model !== undefined && this.model.HasReferencedVoucherTo && !(this.formGroup.touched && this.formGroup.valid);
  }
  voucherConfirm() {
    if (
      this.isValid() &&
      (this.formGroup.controls["StatusKindCode"].value === InvStatusKind.Registered ||
        this.formGroup.controls["StatusKindCode"].value === InvStatusKind.Confirmed)
    ) {
      this.lookupservice
        .getLookupbyCode(
          "SELL",
          "StatusKind",
          this.model.StatusKindCode === InvStatusKind.Confirmed ? InvStatusKind.Registered : InvStatusKind.Confirmed
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            if (this.formGroup.controls["StatusKindCode"].value === InvStatusKind.Confirmed) {
              this.currentVoucherKind.HasAutoConfirm = false;
              this.currentVoucherKind.HasJournalVoucherAuto = false;
              this.currentVoucherKind.AutoFocusedDocumentIssuance = false;
            }
            this.model.StatusKindId = x.Id;
            this.model.StatusKindCode = x.Code;
            this.model.StatusKindTitle = x.Title;
            this.setValue("StatusKindId", x.Id);
            this.setValue("StatusKindCode", x.Code);
            this.setValue("StatusKindTitle", x.Title);
            if (this.model.StatusKindCode === InvStatusKind.Confirmed) this.confirmLabel = "برگشت از تایید";
            else this.confirmLabel = "تایید سند";

            this.save();
          }
        });
    }
  }
  delete_Voucher() {
    this.sts.showToast("primary", "", "در حال حذف...");
    this.httpCommonService
      .delete(this.apiName, this.model.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        async (results) => {
          this.sts.showToast("success", "", "اطلاعات با موفیت حذف شد.");
          this.model = undefined;
          this.currentrow = undefined;
          await this.ngOnInit();
        },
        (error) => {
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در حذف اطلاعات");
        }
      );
  }
  deleteVoucher() {
    this.sts.showDialog(`آیا از حذف سند اطمینان دارید؟`, "حذف سند", DialogType.confirm, () => this.delete_Voucher());
  }
  async newVoucher() {
    this.isNewVoucher = true;
    if (this.canDeactivate()) {
      this.isClosing = false;
      this.selectorService.submitted$.next(false);
      this.model = undefined;
      this.currentrow = undefined;
      await this.ngOnInit();
    }
  }

  async voucherRefrenceTo() {
    if (!this.model.HasReferencedVoucherTo) await this.CreateVoucherKindReferencedTo(null);
    else this.erroremessage = "برای این سند قبلا معطوف صادر شده است.";
  }
  async accountAccVoucher(create: boolean = true) {
    if (create && this.model.StatusKindCode < SellStatusKind.Confirmed) {
      this.sts.showDialog(`سند تایید نشده است.`, "خطا");
      return;
    }
    if (this.canDeactivate()) {
      let gridFilter: GridFilter[] = [];
      let SellVoucherHeaderIds: number[] = [];
      SellVoucherHeaderIds.push(this.model.Id);
      let filter: GridFilter = {
        Type: "F",
        Filed: "SellVoucherHeaderIds",
        Value: SellVoucherHeaderIds,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 0,
      };
      gridFilter.push(filter);
      if (this.model.AccVoucherFixNumber !== undefined && this.model.AccVoucherFixNumber > 0 && !create) await this.deleteAccVoucher(gridFilter);
      else if (create && this.model.StatusKindCode === SellStatusKind.Confirmed) await this.createAccVoucher(gridFilter);
    }
  }
  async createAccVoucher(gridFilter: GridFilter[]) {
    if (this.isCreatingAccVoucher === true) return;
    if (this.model.SellVoucherDetailList.some((x) => !x.UnitPrice)) {
      this.CreatingAccVoucherHasError = true;
      this.sts.showDialog(`به علت نداشتن فی بعضی از اقلام امکان صدور سند حسابداری وجود نداره.`, "خطا");
      return;
    }
    this.isCreatingAccVoucher = true;
    this.splashFormService.openDialog("", "در حال صدور سند حسابداری");
    await this.httpCommonService
      .create(this.apiName + "/CreateAccVoucher", gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        async (x) => {
          if (x) {
            this.splashFormService.closeLoading();
            this.tabsservice.tabItemonRefreshData.next(this.apiName);
            this.sts.showDialog("سند با موفقیت صادر شد.", "");
            this.accVoucherCaption = "حذف سند حسابداری";
            await this.ngOnInit();
            this.isRefreshingData = false;
            this.isCreatingAccVoucher = false;
          }
        },
        async (error) => {
          this.CreatingAccVoucherHasError = true;
          this.isRefreshingData = false;
          await this.ngOnInit();
          this.currentVoucherKind.HasJournalVoucherAuto = false;
          this.splashFormService.closeLoading();
          this.sts.showDialog(` خطا در صدور اسناد ${Utilities.getHttpResponseMessage(error)}`, "خطا");
          this.isCreatingAccVoucher = false;
        }
      );
  }
  async deleteAccVoucher(gridFilter: GridFilter[]) {
    this.splashFormService.openDialog("", "در حال حذف سند حسابداری");
    this.currentVoucherKind.HasJournalVoucherAuto = false;
    await this.httpCommonService
      .create(this.apiName.split("/")[0] + "/DeleteAccVoucher", gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        async (x) => {
          if (x) {
            this.splashFormService.closeLoading();
            await this.ngOnInit();
            this.currentVoucherKind.HasJournalVoucherAuto = false;
            this.tabsservice.tabItemonRefreshData.next(this.apiName);
            this.sts.showDialog("سند با موفقیت حذف شد.", "");
            this.accVoucherCaption = "سند حسابداری";
          }
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(` خطا در حذف اسناد  ${Utilities.getHttpResponseMessage(error)}`, "خطا");
        }
      );
  }
  viewAccVoucher() {
    this.httpCommonService
      .getItem(this.apiName + "/ViewAccVoucher", this.model.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          var datatrasfer: Datatransfer = <Datatransfer>{};
          datatrasfer.apiName = this.apiName;
          datatrasfer.label = "سند حسابداری";
          datatrasfer.areaName = "Accounting";
          datatrasfer.currentrow = x;
          const menu = <ITab>{
            title: `سند حسابداری-(نمایش)`,
            isCloseable: true,
            active: true,
            responsive: true,
            componentType: AccVoucherFormComponent,
            // modulePath: this.tabsservice.getActiveTab().modulePath,
            data: [
              { provide: EntityBase, useValue: x },
              { provide: Datatransfer, useValue: datatrasfer },
              { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: x[""] } },
            ],
          };
          this.tabsservice.open(menu);
        },
        (error) => this.sts.showDialog(` خطا در نمایش سند: ${Utilities.getHttpResponseMessage(error)}`, "خطا")
      );
  }

  private async SetPriceUnit(IsOverWriteable: boolean, data: SellVoucherDetail = undefined) {
    if (
      !this.formGroup?.get("SellkindId")?.value ||
      this.formGroup?.get("StatusKindCode")?.value > 1 ||
      (!this.currentVoucherKind.CanChangeReferePrice &&
        (this.formGroup?.get("ReferenceVoucherKindId")?.value ||
          (this.currentVoucherKind.ReferenceVoucherKinds != null && this.currentVoucherKind.ReferenceVoucherKinds.length > 0)) &&
        (this.model.SellVoucherDetailList == null || (this.model.SellVoucherDetailList.length <= 0 && !this.detail?.formGroup && !data)))
    )
      return;
    if (!this.formGroup?.get("CustomerGroupId")?.value || !this.formGroup?.get("SellkindId")?.value) return;
    if (
      (!this.detail || !this.detail?.formGroup || !this.detail?.formGroup?.get("GoodsId")?.value) &&
      (!this.model!.SellVoucherDetailList || !this.model.SellVoucherDetailList.some((x) => x.GoodsId)) &&
      !data &&
      !data?.GoodsId
    )
      return;
    var filters: GridFilter[] = [];
    filters.push(<GridFilter>{ Type: "F", Filed: "CurrentBranchId", Value: this.model.BranchId, Operator: "eq", Skip: 0, Take: 0 });
    filters.push(<GridFilter>{ Type: "F", Filed: "FiscalYearId", Value: this.model.FiscalYearId, Operator: "eq", Skip: 0, Take: 0 });
    if (this.formGroup?.get("VoucherDate")?.value)
      filters.push(<GridFilter>{
        Type: "F",
        Filed: "PriceListDate",
        Value: this.formGroup?.get("VoucherDate")?.value,
        Operator: "eq",
        Skip: 0,
        Take: 0,
      });
    if (this.formGroup?.get("CustomerGroupId")?.value)
      filters.push(<GridFilter>{
        Type: "F",
        Filed: "CustomerGroupId",
        Value: this.formGroup?.get("CustomerGroupId")?.value,
        Operator: "eq",
        Skip: 0,
        Take: 0,
      });
    filters.push(<GridFilter>{ Type: "F", Filed: "SellKindId", Value: this.formGroup?.get("SellkindId")?.value, Operator: "eq", Skip: 0, Take: 0 });
    filters.push(<GridFilter>{
      Type: "F",
      Filed: "GoodsId",
      Value: data?.GoodsId ?? (!IsOverWriteable ? this.detail?.formGroup?.get("GoodsId")?.value ?? 0 : 0),
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });
    filters.push(<GridFilter>{
      Type: "F",
      Filed: "GoodsUnitId",
      Value: data?.GoodsUnitId ?? (!IsOverWriteable ? this.detail?.formGroup?.get("GoodsUnitId")?.value ?? 0 : 0),
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });

    await this.httpCommonService
      .GetFilterGrid<PriceListDetail[]>("PriceListHeader/GetByPriceListDetail", filters)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (CurrentPriceList) => {
          if (CurrentPriceList && CurrentPriceList?.length > 0) {
            if (!CurrentPriceList && IsOverWriteable === true && this.currentVoucherKind.IncrementalKindCode !== 1) {
              if (data) {
                data.UnitPrice = 0;
                data.DiscountRate = 0;
              } else {
                this.detail?.formGroup?.get("UnitPrice")?.setValue(0);
                this.detail?.formGroup?.get("DiscountRate")?.setValue(0);
              }
            } else if (CurrentPriceList && this.currentVoucherKind.IncrementalKindCode !== 1) {
              if (data) {
                if (!data.UnitPrice || (IsOverWriteable === true && CurrentPriceList[0].IsFinal) || !data?.UnitPrice)
                  data.UnitPrice = CurrentPriceList[0].UnitPrice;

                if ((IsOverWriteable === true && CurrentPriceList[0].DiscountIsFinal) || !data?.DiscountRate || data?.DiscountRate == 0)
                  data.DiscountRate = CurrentPriceList[0].DiscountRate;
                this.detail?._setChanges(data);
                this.detail?.cd?.markForCheck();
              } else {
                if (
                  !this.detail?.formGroup?.get("UnitPrice")?.value ||
                  IsOverWriteable === true ||
                  this.detail?.formGroup?.get("UnitPrice")?.value === 0
                )
                  this.detail?.formGroup?.get("UnitPrice")?.setValue(CurrentPriceList[0].UnitPrice);

                if (
                  IsOverWriteable === true ||
                  !this.detail?.formGroup?.get("DiscountRate")?.value ||
                  this.detail?.formGroup?.get("DiscountRate")?.value == 0
                )
                  this.detail?.formGroup?.get("DiscountRate").setValue(CurrentPriceList[0].DiscountRate);
              }
              if (this.detail?.formGroup && CurrentPriceList[0].IsFinal) {
                if (this.detail.formGroup.get("GoodsId")?.value === CurrentPriceList[0].GoodsId) this.detail.formGroup.get("UnitPrice")?.disable();
              } else if (this.detail?.formGroup && this.detail.formGroup.get("GoodsId")?.value === CurrentPriceList[0].GoodsId) {
                this.detail.formGroup.get("UnitPrice").enable();
                this.detail.columns.find((c) => c.name == "UnitPrice").disabled = false;
              }
              if (this.detail && CurrentPriceList[0].DiscountIsFinal) {
                if (this.detail.formGroup?.get("GoodsId")?.value === CurrentPriceList[0].GoodsId) {
                  this.detail.formGroup?.get("DiscountRate")?.disable();
                  this.detail.formGroup?.get("DiscountAmount")?.disable();
                }
              } else if (this.detail && this.detail.formGroup.get("GoodsId")?.value === CurrentPriceList[0].GoodsId) {
                this.detail.columns.find((c) => c.name == "DiscountRate").disabled = false;
                this.detail.columns.find((c) => c.name == "DiscountAmount").disabled = false;
                this.detail?.formGroup?.get("DiscountRate")?.enable();
                this.detail?.formGroup?.get("DiscountAmount")?.enable();
              }
            } else if (this.detail) {
              this.detail.columns.find((c) => c.name == "DiscountRate").disabled = false;
              this.detail.columns.find((c) => c.name == "DiscountAmount").disabled = false;
              this.detail.columns.find((c) => c.name == "UnitPrice").disabled = false;
              this.detail?.formGroup?.get("UnitPrice")?.enable();
              this.detail?.formGroup?.get("DiscountRate")?.enable();
              this.detail?.formGroup?.get("DiscountAmount")?.enable();
              this.detail?.formGroup?.get("Price")?.enable();
            }
          }
          this.cd.markForCheck();
        },
        (error) => console.log(error)
      );
  }
  SetHasPricelist() {
    this.httpCommonService
      .getList("PriceListHeader/HasAnyRecord")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: boolean) => {
          this.HasPricelist = data;
        },
        (err) => {
          this.sts.showDialog("اشکال در ارتباط با سرویس", "توجه");
          console.log(err);
        }
      );
  }
  ResetPriceUnit() {
    if (!this.Priceable || this.model.StatusKindCode > SellStatusKind.Registered) return;
    if (
      (!this.currentVoucherKind.CanChangeReferePrice || !this.Priceable) &&
      (this.formGroup?.get("ReferenceVoucherKindId")?.value ||
        (this.currentVoucherKind.ReferenceVoucherKinds != null && this.currentVoucherKind.ReferenceVoucherKinds.length > 0)) &&
      (!this.model.SellVoucherDetailList || this.model.SellVoucherDetailList.length <= 0)
    )
      return;
    let IsOverWriteable = false;
    if (this.HasPricelist === true && this.model.SellVoucherDetailList.some((x) => x.State !== RowState.Delete && x.State !== RowState.Detached)) {
      this.model.SellVoucherDetailList.forEach(async (data) => {
        await this.SetPriceUnit(true, data);
      });
      if (this.detail) this.detail.dataList = this.model.SellVoucherDetailList;
      this.cd.markForCheck();
    } else {
      return;
    }
  }
  onvalueChangeWithName($event) {
    if ($event && $event?.name === "TotalDiscount" && $event.value) {
      this.model.SellVoucherDetailList.forEach((x) => {
        x.DiscountRate = $event.value;
        this.detail?._setChanges(x);
      });
    }
    this.setSummery();
    this.cd.markForCheck();
  }
  async changeReport(reprtName: string) {
    if (!this.formGroup?.get("CustomerId")?.value) return;
    await this.getCustomerRemain();
    super.changeReport(reprtName);
  }
}
